/**
 * @generated SignedSource<<0e68ca969e6af973adcac73b40f14e68>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type SpaceCreationEligibility_space$data = {
  readonly key: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"ContextualCreateContentButton_space" | "FooterCreateButtons_space" | "useSpaceEnabledContentTypes_space">;
  readonly " $fragmentType": "SpaceCreationEligibility_space";
};
export type SpaceCreationEligibility_space$key = {
  readonly " $data"?: SpaceCreationEligibility_space$data;
  readonly " $fragmentSpreads": FragmentRefs<"SpaceCreationEligibility_space">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "SpaceCreationEligibility_space",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "key"
    },
    {
      "kind": "FragmentSpread",
      "name": "FooterCreateButtons_space"
    },
    {
      "kind": "FragmentSpread",
      "name": "useSpaceEnabledContentTypes_space"
    },
    {
      "kind": "FragmentSpread",
      "name": "ContextualCreateContentButton_space"
    }
  ],
  "type": "Space"
};

(node as any).hash = "86ebdf059e3b96c0adbb17f3a4baea25";

export default node;
